import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { createFetch } from "../../../../helpers/fetch/FetchRequest";
import { getCookie } from "../../../../helpers/common";
import Loading from "../../../../components/Loading";
import styles from "./Deployments.module.scss";
import Deployment from "./components/deployment/Deployment";
import { CardItem } from "../../../../components/card/Card";
import BuilderWebSocket from "./components/BuilderWebSocket";
import { API_BUILDER_DEPLOYMENTS_GET_NODE } from "../../../../settings/endpoints/stacker";
import { USER_ACCESS_TOKEN_NAME } from "../../../../settings/global";

function Deployments({project, userFetchStatus, clouds, ssl}) {

    const router = useRouter();

    const [deployments, setDeployments] = useState([]);
    const [loading, setLoading] = useState(true);

    const getDeployments = () => {
        createFetch({
            URL: `${API_BUILDER_DEPLOYMENTS_GET_NODE}?project=${project.id}`,
            headers: {'Authorization': 'Bearer ' + getCookie(USER_ACCESS_TOKEN_NAME)},
            onSuccess: res => {
                if (!!res?.length) {
                    const filtered = res?.filter(d => !d.deleted);
                    const sorted = filtered?.sort((a, b) => new Date(b._updated) - new Date(a._updated));
                    setDeployments(sorted.map(d => ({...d, ...{request_dump: JSON.parse(d.request_dump)}})))
                } else {
                    setDeployments([]);
                }
                setLoading(false);
            },
            onError: res => {
                setLoading(false);
            },
        })
    }

    useEffect(() => {
        if (userFetchStatus === 'success' && !!router.query.project) {
            if (!!project) getDeployments();
        } else {
            setDeployments([]);
        }
    }, [userFetchStatus, router.query.project, project]);

    if (loading) return <Loading/>;

    return (
        // <Card title={`My deployments`} darker={!dark}>
        <>
            <BuilderWebSocket getDeployments={getDeployments}/>
            {/*<DashboardWebSocket/>*/}
            {
                !!deployments?.length
                    ? deployments.map((deployment, index) => (
                        <Deployment
                            deployment={deployment}
                            deploymentLoading={loading}
                            clouds={clouds}
                            key={index}
                            ssl={ssl}
                        />
                    ))
                    :
                    <CardItem className={styles.empty}>
                        <p className={styles.empty__text}>Nothing to show yet</p>
                    </CardItem>
            }
        </>
    )
}

export default Deployments